import { render, staticRenderFns } from "./FormRegistro.vue?vue&type=template&id=40b89ca9"
import script from "./FormRegistro.vue?vue&type=script&setup=true&lang=js"
export * from "./FormRegistro.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports